import {METHOD} from "./method";

export const API_CONTRACT_NON_EMPLOYEE = {
    CONTRACT_LIST: {
        api: '/v1/hr-adm/non-worker-contract/list',
        method: METHOD.POST
    },
    EMPLOYEE_LIST: {
        api: '/v1/hr-adm/non-worker-contract/employees',
        method: METHOD.GET
    },
    EMPLOYEE_DETAIL: {
        api: '/v1/hr-adm/non-worker-contract/employee',
        method: METHOD.GET
    },
    CONSTANT: {
        api: '/v1/hr-adm/non-worker-contract/constant',
        method: METHOD.GET
    },
    LIST_COMPANY: {
        api: '/v1/hr-adm/non-worker-contract/companies',
        method: METHOD.GET
    },
    LIST_JOB_TITLE: {
        api: '/v1/hr-adm/non-worker-contract/job-titles',
        method: METHOD.GET
    },
    LIST_GRADE: {
        api: '/v1/hr-adm/non-worker-contract/grades',
        method: METHOD.GET
    },
    ALLOWANCE: {
        api: '/v1/hr-adm/non-worker-contract/grade-allowances',
        method: METHOD.GET
    },
    CREATE_CONTRACT: {
        api: '/v1/hr-adm/non-worker-contract',
        method: METHOD.POST
    },
    PREVIEW_DETAIL: {
        api: '/v1/hr-adm/non-worker-contract/preview',
        method: METHOD.GET
    },
    EXPORT: {
        api: '/v1/hr-adm/non-worker-contract/list/export',
        method: METHOD.POST
    },
    DETAIL_CONTRACT_HISTORY: {
        api: '/v1/hr-adm/non-worker-contract/history',
        method: METHOD.GET
    },
    DETAIL_CONTRACT: {
        api: '/v1/hr-adm/non-worker-contract',
        method: METHOD.GET
    },
    DETAIL_CONTRACT_INFORMATION: {
        api: '/v1/hr-adm/non-worker-contract/information',
        method: METHOD.GET
    },
    GET_URL_CONTRACT_DOCUMENT: {
        api: '/v1/hr-adm/non-worker-contract/storage-url/document',
        method: METHOD.POST
    },
    UPLOAD_CONTRACT_DOCUMENT: {
        api: '/v1/hr-adm/non-worker-contract/upload',
        method: METHOD.POST
    },
    UPLOAD_ADDENDUM_CONTRACT_DOCUMENT: {
        api: '/v1/hr-adm/non-worker-contract/addendum/upload',
        method: METHOD.POST
    },
    UPLOAD_RENEW_CONTRACT_DOCUMENT: {
        api: '/v1/hr-adm/non-worker-contract/renew/upload',
        method: METHOD.POST
    },
    EDIT_CONTRACT: {
        api: '/v1/hr-adm/non-worker-contract',
        method: METHOD.PUT
    },
    ADDENDUM_CONTRACT: {
        api: '/v1/hr-adm/non-worker-contract/addendum',
        method: METHOD.POST
    },
    RENEW_CONTRACT: {
        api: '/v1/hr-adm/non-worker-contract/renew',
        method: METHOD.POST
    },
    COMPLETE_CONTRACT: {
        api: '/v1/hr-adm/non-worker-contract/complete',
        method: METHOD.POST
    },
    DELETE_CONTRACT: {
        api: '/v1/hr-adm/non-worker-contract/delete',
        method: METHOD.POST
    },
    LIST_JOB_UNIT: {
        api: '/v1/hr-adm/non-worker-contract/job-unit',
        method: METHOD.POST
    },
}
